export const feedbackInitialValues = {
  feature: "",
  details: "",
};
